<div class="add-provider-wrapper" *transloco="let t">
  @if (!(isUserRoleRepresentative$ | async)) {
  <div class="add-provider-header">
    <xt-portal-page-header
      [backlink]="backlink"
      [title]="t('app.privacyCockpit.title')"
      [xTentionDummyCypress]="'privacy-cockpit.add-provider.header.close'"
      (backlinkClick)="closeDialog()"
    />
  </div>
  }
  <xt-ui-kit-tab-group>
    @for (addProviderTab of addProviderTabs; track addProviderTab) {
    <xt-ui-kit-tab [label]="t(addProviderTab.label)">
      <xt-portal-filter-provider-form
        [addProvider]="true"
        [filterFields]="addProviderTab.filterFields"
        (resetHandler)="addProviderTab.providerService.clearData()"
        (searchHandler)="
          addProviderTab.providerService.fetchDataByParams($event)
        "
      />
      <div class="search-results accordion-wrapper blue">
        <mat-accordion [hideToggle]="false">
          <mat-expansion-panel
            [hideToggle]="false"
            [expanded]="true"
            class="mat-elevation-z"
          >
            <mat-expansion-panel-header>
              <mat-panel-title class="panel-title">
                <span>{{ t('app.privacyCockpit.searchResults') }}</span>
                <hr class="horizontal-line" />
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="accordion-body">
              @if ((addProviderTab.providerService.data$ | async)?.length) {
              <xt-portal-table
                [dataCy]="'privacy-cockpit.add-provide.table'"
                [allColumns]="addProviderTab.table.allColumns"
                [tabletColumns]="addProviderTab.table.tabletColumns"
                [mobileColumns]="addProviderTab.table.mobileColumns"
                [data]="addProviderTab.providerService.data$ | async"
                (rowClickHandler)="openDetailPage($event)"
              />
              } @else {
              <p>{{ t('app.privacyCockpit.noEntriesFound') }}</p>
              }
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </xt-ui-kit-tab>
    }
  </xt-ui-kit-tab-group>
</div>
